import { CheckOutlined } from '@ant-design/icons';
import { Checkbox, Input, Select, Spin, Space } from 'antd';

const { Option } = Select;

const PrestationsSelector = ({
  selectedPrestations,
  activePrestationKey,
  activePrestation,
  onSelectActive,
  onAddPrestation,
  onRemovePrestation,
  servicesList,
  loading,
  onSearch,
  onToggleKeyword,
  observacionesProtocolo,
  observacionesOtras,
  getLegendClass,
}) => {
  return (
    <div className="prestations-selector">
      <h2 className="mb-15">Prestaciones</h2>
      <p className="mb-10 fs-12 color-secondary">Seleccione para añadir al listado</p>

      <Space size="middle" className="service-legend-wrapper mb-15">
        <div className="service-legend-wrapper__item">
          <div className="legend-dot legend-dot--battery" /> <span>Batería</span>
        </div>
        <div className="service-legend-wrapper__item">
          <div className="legend-dot legend-dot--exam" /> <span>Examen individual</span>
        </div>
        <div className="service-legend-wrapper__item">
          <div className="legend-dot legend-dot--protocol" /> <span>Protocolo</span>
        </div>
      </Space>

      <Spin spinning={loading.service} className="cmt-spin">
        <Select
          className="cmt-select w-100 mb-20"
          showSearch
          allowClear
          filterOption={false}
          placeholder="Prestaciones"
          onSearch={onSearch}
          onSelect={(value, option) => {
            onAddPrestation(option);
          }}
          onClear={() => { }}
          notFoundContent={null}
          value={null}
        >
          {servicesList?.length > 0 && servicesList.map((service) => {
            const isSelected = selectedPrestations.some(prestation => prestation.id === service.id && prestation.type === service.type);
            return (
              <Option
                key={`${service.id}-${service.type}`}
                value={`${service.id}-${service.type}`}
                serviceData={service}
                disabled={isSelected}
              >
                <div className="service-select-item">
                  <div className={`legend-dot ${getLegendClass(service.type)}`} />
                  <span className={isSelected ? 'service-selected-text' : ''}>{service.name}</span>
                  {isSelected && <CheckOutlined className="service-check-icon" />}
                </div>
              </Option>
            );
          })}
        </Select>
      </Spin>

      {selectedPrestations?.length > 0 && (
        <>
          <h3 className="mb-10">Listado seleccionado</h3>
          <div className="selected-prestations-list mb-20">
            {selectedPrestations?.length > 0 && [...selectedPrestations]
              .sort((prestationA, prestationB) => {
                const getWeight = (item) => {
                  if (item.department_id === 1 && item.type === 'Battery') return 1;
                  if (item.department_id === 2 && item.type === 'Battery') return 2;
                  return 3;
                };

                return getWeight(prestationA) - getWeight(prestationB);
              })
              .map((prestation) => {
                const key = `${prestation.id}-${prestation.type}`;
                const isActive = key === activePrestationKey;
                return (
                  <div
                    key={key}
                    className={`selected-prestation-item ${isActive ? 'selected-prestation-item--active' : ''}`}
                    onClick={() => onSelectActive(key)}
                  >
                    <div className={`legend-dot ${getLegendClass(prestation.type)}`} />
                    <span className="prestation-name">{prestation.name}</span>
                    <span
                      className="icon-system-delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemovePrestation(key);
                      }}
                    />
                  </div>
                );
              })}
          </div>
        </>
      )}

      {activePrestation?.availableKeywords?.length > 0 && (
        <div className="conditionals-section mb-20">
          <h3 className="mb-10">Otras condicionales</h3>
          <Spin spinning={loading.conditional} className="cmt-spin">
            {activePrestation.availableKeywords.map((keyword) => (
              <div key={keyword} className="mb-5">
                <Checkbox
                  className="cmt-checkbox secondary"
                  checked={activePrestation.selectedKeywords?.includes(keyword)}
                  onChange={() => onToggleKeyword(keyword)}
                >
                  {keyword}
                </Checkbox>
              </div>
            ))}
          </Spin>
        </div>
      )}

      <div className="observations-section">
        <h3 className="mb-10">Observaciones</h3>
        {selectedPrestations?.filter(p => p.observations).map((p) => (
          <div className="mb-10" key={`${p.id}-${p.type}`}>
            <p className="mb-5 fs-12"><strong>Por protocolo ({p.name}):</strong></p>
            <Input.TextArea
              value={p.observations}
              placeholder="Sin observaciones por protocolo"
              disabled
              autoSize={{ minRows: 2, maxRows: 4 }}
              className="cmt-input"
            />
          </div>
        ))}

        {(!selectedPrestations || !selectedPrestations.some(p => p.observations)) && (
          <div className="mb-10">
            <p className="mb-5 fs-12"><strong>Por protocolo:</strong></p>
            <Input.TextArea
              value=""
              placeholder="Sin observaciones por protocolo"
              disabled
              autoSize={{ minRows: 2, maxRows: 4 }}
              className="cmt-input"
            />
          </div>
        )}

        <div>
          <p className="mb-5 fs-12"><strong>Otras:</strong></p>
          <Input.TextArea
            value={observacionesOtras || ''}
            placeholder="Sin observaciones"
            disabled
            autoSize={{ minRows: 2, maxRows: 4 }}
            className="cmt-input"
          />
        </div>
      </div>
    </div>
  );
};

export default PrestationsSelector;
